import { ReactNode } from "react";
import { I18nProvider } from "@lingui/react";
import { useI18n } from "src/hooks/stores/use-i18n-store";

export function TranslationProvider({ children }: { children: ReactNode }) {
  const i18n = useI18n();

  return <I18nProvider i18n={i18n}>{children}</I18nProvider>;
}
